"use client";

import { useTranslations } from "next-intl";
import {
    LiveDashboardImage1,
    LiveDashboardImage2,
    LiveDashboardImage3,
    LiveDashboardImage4,
    LiveDashboardImage5,
    LiveDashboardImage6,
    LiveDashboardImage7,
    LiveDashboardImage8,
    LiveDashboardImage9,
    LiveDashboardImage10,
    LiveDashboardImage11,
} from "../../assets";
import UserGuideImage from "./UserGuideImage";

export default function HowToUseLiveDashboardGuide() {
    const t = useTranslations("howToUseLiveDashboard");

    return (
        <article className="mx-auto max-w-4xl px-6 py-8 text-[15px] leading-relaxed text-neutral-800 sm:px-10 sm:py-10 sm:text-base">
            <h1 className="mb-8 text-center text-xl font-bold sm:text-2xl">
                {t("headerTitle")}
            </h1>

            <div className="mb-8">
                <UserGuideImage image={LiveDashboardImage1} />
            </div>

            <p className="mb-5 indent-8 text-justify">{t("title1")}</p>
            <p className="mb-5 indent-8 text-justify">{t("title2")}</p>
            <p className="mb-6 indent-8 text-justify">{t("title3")}</p>

            <div className="mb-6">
                <UserGuideImage image={LiveDashboardImage2} />
            </div>

            <div className="mb-6">
                <UserGuideImage image={LiveDashboardImage3} />
            </div>

            <p className="mb-6 indent-8 text-justify">{t("title4")}</p>

            <div className="mb-6">
                <UserGuideImage image={LiveDashboardImage4} />
            </div>

            <div className="mb-6">
                <UserGuideImage image={LiveDashboardImage5} />
            </div>

            <p className="mb-5 indent-8 text-justify">{t("title5")}</p>
            <p className="mb-6 indent-8 text-justify">{t("title6")}</p>

            <div className="mb-6 flex flex-col items-center gap-4 sm:flex-row sm:items-end sm:justify-center sm:gap-6">
                <div className="w-full sm:max-w-[660px]">
                    <UserGuideImage image={LiveDashboardImage6} />
                </div>
                <div className="w-full sm:max-w-[250px]">
                    <UserGuideImage image={LiveDashboardImage7} />
                </div>
            </div>

            <h2 className="mb-4 indent-4 text-base font-bold sm:text-lg">
                {t("stepTitle")}
            </h2>

            <p className="mb-4 indent-4 text-justify">{t("step1")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step2")}</p>

            <div className="mb-6">
                <UserGuideImage image={LiveDashboardImage8} />
            </div>

            <p className="mb-4 indent-4 text-justify">{t("step3")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step4")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step5")}</p>

            <div className="mb-6">
                <UserGuideImage image={LiveDashboardImage9} />
            </div>

            <p className="mb-4 indent-4 text-justify">{t("step6")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step7")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step8")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step9")}</p>

            <div className="mb-6">
                <UserGuideImage image={LiveDashboardImage10} />
            </div>

            <p className="mb-4 indent-4 text-justify">{t("step10")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step11")}</p>
            <p className="mb-4 indent-4 text-justify">{t("step12")}</p>
            <p className="mb-6 indent-4 text-justify">{t("step13")}</p>

            <div className="mb-2">
                <UserGuideImage image={LiveDashboardImage11} />
            </div>
        </article>
    );
}
